module.exports = __webpack_public_path__ + "images/_/programs/epsPrimaries/images/characters/sara_surprised-61e177ce1eeefefed54cdf3a77a4bf34.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsPrimaries/images/characters/sara_surprised.png
// module id = 881
// module chunks = 2